import Desktop from '../ScrollPage/index.desktop';

export default Desktop;
